'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var userProviderDetailsController = function () {
  function userProviderDetailsController() {
    "ngInject";

    (0, _classCallCheck3.default)(this, userProviderDetailsController);
  }

  (0, _createClass3.default)(userProviderDetailsController, [{
    key: 'clientsCount',
    value: function clientsCount() {
      var count = this.user.providerInfo.clientsCount;
      if (!count) count = 0;

      return count;
    }
  }, {
    key: 'totalRevenue',
    value: function totalRevenue() {
      var value = this.user.stats.totalRevenue;
      if (!value) value = 0;

      return kendo.toString(value, 'c0');
    }
  }, {
    key: 'totalRevenue12Months',
    value: function totalRevenue12Months() {
      var value = this.user.stats.totalRevenue12Months;
      if (!value) value = 0;

      return kendo.toString(value, 'c0');
    }
  }, {
    key: 'totalHours',
    value: function totalHours() {
      var value = this.user.stats.totalWorkingHours;
      if (!value) value = 0;

      return kendo.toString(value, 'n0');
    }
  }, {
    key: 'membershipFees',
    value: function membershipFees() {
      var total = 0;
      this.user.invoices.forEach(function (invoice) {
        total += invoice.adjustedTotal - invoice.amountRefunded;
      });

      total /= 100;

      return total;
    }
  }, {
    key: 'membershipFeesFormatted',
    value: function membershipFeesFormatted() {
      var total = this.membershipFees();

      return kendo.toString(total, 'c0');
    }
  }, {
    key: 'membershipPercentage',
    value: function membershipPercentage() {
      var membershipFees = this.membershipFees();
      var totalRevenue = this.user.stats.totalRevenue;
      if (!membershipFees || !totalRevenue) return '';

      return kendo.toString(membershipFees / totalRevenue, 'p2') + ' of estimated revenue';
    }
  }]);
  return userProviderDetailsController;
}();

exports.default = userProviderDetailsController;


/** WEBPACK FOOTER **
 ** ./client/app/common/Components/user-provider-details/user-provider-details.controller.js
 **/